import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  B2BPortalOperations,
  B2BPortalInstant,
  B2BPortalScalability,
  B2BPortalAnywhereAccess,
  B2BPortalRealTime,
  B2BPortalSecurity,
  B2BPortalSeamless,
  B2BPortalFaster,
} from "../../../app-constants-updated";
import { Link } from "gatsby";

function Ecommercewebprocess() {
  return (
    <section
      className="ecommerce_web_process b2b-process p-100"
      style={{ background: "#fff" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Revolutionize Your Business with a <span>Custom B2B</span> Portal
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  01
                  <h5>Streamlined Operations</h5>
                </div>
                <div className="ecom_box_icon">{B2BPortalOperations}</div>
              </div>
              <p>
                Automate repetitive tasks for faster, more efficient workflows.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  02
                  <h5>Instant B2B Interactions</h5>
                </div>
                <div className="ecom_box_icon">{B2BPortalInstant}</div>
              </div>
              <p>
                Enable secure, real-time communication with partners and
                clients.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  03
                  <h5>Effortless Scalability</h5>
                </div>
                <div className="ecom_box_icon">{B2BPortalScalability}</div>
              </div>
              <p>Easily expand your portal as business demands grow.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  04
                  <h5>Anytime, Anywhere Access</h5>
                </div>
                <div className="ecom_box_icon">{B2BPortalAnywhereAccess}</div>
              </div>
              <p>
                Ensure 24/7 access across all devices for continuous business
                flow.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  05
                  <h5>Real-Time Analytics</h5>
                </div>
                <div className="ecom_box_icon">{B2BPortalRealTime}</div>
              </div>
              <p>Leverage immediate insights for informed decision-making.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  06
                  <h5>Advanced Security</h5>
                </div>
                <div className="ecom_box_icon">{B2BPortalSecurity}</div>
              </div>
              <p>
                Protect your data with enterprise-grade encryption and
                compliance protocols.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-md-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  07
                  <h5>Seamless Integration</h5>
                </div>
                <div className="ecom_box_icon">{B2BPortalSeamless}</div>
              </div>
              <p>
                Quickly connect with existing systems and third-party tools.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  08
                  <h5>Faster Growth</h5>
                </div>
                <div className="ecom_box_icon">{B2BPortalFaster}</div>
              </div>
              <p>
                Drive revenue through optimized processes and partner
                engagement.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ecommercewebprocess;
